module.exports = __webpack_public_path__ + "8a5356e9/img/ion_calendar-number.3ac5bd07.svg";